import api from "../api";
import { listData, login } from "../api_endpoints";


export const loginAdmin=async(data)=>{
  try {
      const response = await api.post(login.login, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const forgetPassword=async(data)=>{
  try {
      const response = await api.post(login.forget_password, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const resetPassword=async(data)=>{
  try {
      const response = await api.post(login.reset_password, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}


export const createAdmin=async(data)=>{
  try {
      const response = await api.post(login.admin_create, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const getProfile=async(token)=>{
  try {
    console.log(token);
    
      const response = await api.get(login.get_profile,  {
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${token}`
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const updateProfile=async(data,token)=>{
  try {
    console.log(token);
    
      const response = await api.put(login.updateProfile,data,  {
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${token}`
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const getAllHospitals=async(token)=>{
  try {
    console.log(token);
    
      const response = await api.get(listData.all_hospitals,  {
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${token}`
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const getAllDoctors=async(token)=>{
  try {
    console.log(token);
    
      const response = await api.get(listData.all_doctors,  {
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${token}`
      },
    });
    console.log(response);
    

    return response
    
  } catch (error) {
    throw error
    console.log(error);
    
  }
}

export const getAllDiagnostics=async(token)=>{
  try {
    console.log(token);
    
      const response = await api.get(listData.all_diagnostics,  {
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${token}`
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const getAllMusic=async(token)=>{
  try {
    console.log(token);
    
      const response = await api.get(listData.all_music,  {
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${token}`
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}

export const uploadlMusic=async(token,data)=>{
  try {
    console.log(token);
    
      const response = await api.post(listData.uploadMusic,data,  {
      headers: {
       
        "Authorization":`Bearer ${token}`
      },
    });

    return response
    
  } catch (error) {
    throw error
  }
}